import {CountrySwitch} from '@aboutyou/grpc-clients/tadarida/aysa_api/features/country/v1/country_switch.types';
import {COLORS, Z_INDEXES} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {LanguageCountrySwitchView} from '../../LanguageCountrySwitch/LanguageCountrySwitchView';

interface MetaBarLanguageCountrySwitchProps {
  countrySwitch: CountrySwitch;
}

export const MetaBarLanguageCountrySwitch: React.FC<
  MetaBarLanguageCountrySwitchProps
> = ({countrySwitch}) => {
  return (
    <LanguageCountrySwitchWrapper>
      <StyledLanguageCountrySwitchView
        countrySwitch={countrySwitch}
        labelAndBorderColor={COLORS.Grey1}
        openAs="popup"
        overlayWrapperZIndex={Z_INDEXES.TADARIDA_HEADER_LANGUAGE_SWITCH_POPUP}
        shouldUseBorderOnHover={false}
        shouldDisplayArrowOnHover
      />
    </LanguageCountrySwitchWrapper>
  );
};

const LanguageCountrySwitchWrapper = styled.div`
  display: flex;
  height: 100%;
`;

const StyledLanguageCountrySwitchView = styled(LanguageCountrySwitchView)`
  &&& {
    height: 100%;
  }

  &:hover {
    background-color: ${COLORS.Grey3} !important;
  }
`;
